import { render } from "./CharacterCardFull.vue?vue&type=template&id=1cc036eb&scoped=true"
import script from "./CharacterCardFull.vue?vue&type=script&lang=js"
export * from "./CharacterCardFull.vue?vue&type=script&lang=js"

import "./CharacterCardFull.vue?vue&type=style&index=0&id=1cc036eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc036eb"]])

export default __exports__